import { apiModules } from '@A/controllers/modules.api'
import { useModulesStore } from '@/stores/modules'
import { handleApiError } from '@/shared/utils/handleApiError'

/**
 * Modules service: loads the current organization's module subscriptions
 * into the store. Mainapp components/pages read access via the store.
 */
export const useModulesService = () => {
  const { getOrganizationModules } = apiModules()

  const fetchOrganizationModules = async (organizationId: string): Promise<void> => {
    const store = useModulesStore()

    try {
      store.setLoading(true)
      const response = await getOrganizationModules(organizationId)
      store.setModules(response.modules || [])
    }
    catch (error) {
      handleApiError(error)
      store.setModules([])
    }
    finally {
      store.setLoading(false)
    }
  }

  return {
    fetchOrganizationModules
  }
}
